module.exports = __webpack_public_path__ + "media/img/android-icon-144x144-ac6246b2fcdcb74ae7eab56fe84fab2a.png";